import { SVGAttributes } from "react";

export interface ICheckSvgIconProps{
  width?:number,
  height?:number
}

export default function CheckSvgIcon({width = 89, height = 70,...rest}: ICheckSvgIconProps) {

  
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={height} width={width} {...rest} viewBox="0 0 89 70">
      <path d="M74.9276 2.42772C76.4419 0.986028 78.4571 0.189001 80.5479 0.204821C82.6387 0.220641 84.6416 1.04807 86.1339 2.51252C87.6262 3.97696 88.4913 5.96387 88.5466 8.05399C88.6018 10.1441 87.843 12.174 86.4301 13.7152L43.5376 67.3577C42.8001 68.1521 41.9099 68.7896 40.9203 69.2322C39.9308 69.6747 38.8621 69.9131 37.7783 69.9332C36.6945 69.9532 35.6178 69.7545 34.6125 69.349C33.6072 68.9434 32.6941 68.3393 31.9276 67.5727L3.48311 39.1282C2.69097 38.3901 2.05563 37.5 1.61496 36.511C1.1743 35.522 0.937347 34.4544 0.918247 33.3718C0.899146 32.2893 1.09829 31.214 1.50379 30.2101C1.90929 29.2061 2.51285 28.2942 3.27845 27.5286C4.04405 26.763 4.95601 26.1594 5.95993 25.7539C6.96386 25.3484 8.03917 25.1493 9.12173 25.1684C10.2043 25.1875 11.2719 25.4244 12.2609 25.8651C13.2499 26.3057 14.14 26.9411 14.8781 27.7332L37.3886 50.233L74.7234 2.66422C74.7906 2.58146 74.8624 2.5025 74.9384 2.42772H74.9276Z" fill="#1FAE5C" />
    </svg>
  );
}
